// Configurable API endpoints — override via REACT_APP_* env vars in .env
// Defaults are the current production URLs.
const MAILER_BASE = process.env.REACT_APP_MAILER_API_URL || 'https://mailer.hertzai.com';
const AZURE_BASE = process.env.REACT_APP_AZURE_API_URL || 'https://azurekong.hertzai.com';

const configData = {
  // OTP / Auth
  ToSendotp: `${MAILER_BASE}/send_otp`,
  ToVerifyotp: `${MAILER_BASE}/validate_otp`,
  verify_otp: `${MAILER_BASE}/varify_otp`,
  verifyTeacherByPhone: `${AZURE_BASE}/data/login`,
  verifyOtpWithAzure: `${AZURE_BASE}/data/varify_otp`,
  renew_token: `${MAILER_BASE}/refresh_tokens`,

  // Registration
  registerUser: `${MAILER_BASE}/register_student`,
  registerClient: `${MAILER_BASE}/createclient`,

  // Subscriptions / Payments
  getsubscriptionsbyplans: `${MAILER_BASE}/getallplandetails`,
  AddSubscriptio_By_Phone: `${MAILER_BASE}/addsubscription_by_phone`,
  PaymentUrl: `${MAILER_BASE}/makepayment`,
  deductCredits: `${MAILER_BASE}/deduct-credits`,

  // Chat / AI
  chatBotApi: `${AZURE_BASE}/chatbot/revision`,
  forAllAgents: `${AZURE_BASE}/chat/custom_gpt`,
  personalisedLearningAgent: `${AZURE_BASE}/chat/teachme2`,

  // Agent creation (Azure)
  uploadImage: `${AZURE_BASE}/makeit/upload_image/`,
  uploadAudio: `${AZURE_BASE}/makeit/upload_audio`,
  createPrompt: `${AZURE_BASE}/db/create_prompt`,
  uploadFile: `${AZURE_BASE}/makeit/upload_file`,
  bookParsingUpload: `${AZURE_BASE}/book_parsing/book_parsing_upload_api`,
};

export default configData;
